const NAME_OVERRIDES: Record<string, Record<string, string>> = {
	en: { TR: "Turkey" },
};

const regionNamesByLang = new Map<string, Intl.DisplayNames>();

function getRegionNames(lang: string): Intl.DisplayNames {
	const existing = regionNamesByLang.get(lang);
	if (existing) return existing;
	const instance = new Intl.DisplayNames([lang, "tr"], { type: "region" });
	regionNamesByLang.set(lang, instance);
	return instance;
}

export function localizedCountryName(
	code: string | null | undefined,
	fallbackName?: string | null,
	lang: string = "tr",
): string {
	if (!code) return fallbackName ?? "";
	const upperCode = code.toUpperCase();
	const override = NAME_OVERRIDES[lang]?.[upperCode];
	if (override) return override;
	try {
		const name = getRegionNames(lang).of(upperCode);
		if (name && name.toUpperCase() !== code.toUpperCase()) return name;
	} catch {
		// standart olmayan kod; aşağıda ham isme düşülür
	}
	return fallbackName ?? code;
}
